<template>
  <ContentSection>
    <Container indent="lg-but-on-mobile-default" class="grid w-full max-md:gap-6 md:grid-cols-2">
      <!-- TEXT -->
      <div
        class="flex flex-col justify-center md:py-5"
        :class="mapPosition === 'right' ? 'order-1 md:pr-12 xl:pr-18' : 'order-2 md:pl-12 xl:pl-18'"
      >
        <!-- Title -->
        <h2
          v-if="data.heading"
          v-animate-in-from-bottom
          class="mb-5 typo-heading-md lg:typo-heading-3xl"
          v-html="data.heading"
        />

        <!-- Text -->
        <div v-animate-in-from-bottom class="mb-5 typo-body-xl link lg:typo-body-2xl md:mb-8" v-html="data.text" />
      </div>

      <!-- MAP -->
      <div :class="mapPosition === 'right' ? 'order-2' : 'order-1'">
        <div
          v-animate-zoom-in
          class="aspect-[516/431] max-h-[60vh]"
        >
          <GoogleMaps
            :lat="data.lat"
            :lng="data.lng"
            class="overflow-hidden"
            :class="mapPosition === 'right' ? 'rounded-tr-100' : 'rounded-tl-100'"
          />
        </div>
      </div>
    </Container>
  </ContentSection>
</template>

<script lang="ts" setup>
import type { ComponentsMainTeaserMapFragment } from '#gql'

const props = defineProps<{
  data: Enforce<ComponentsMainTeaserMapFragment>
  prevComponent?: string | null
  nextComponent?: string | null
}>()

const mapPosition = computed(() => {
  return props.data.map_position?.value === 'right' ? 'right' : 'left'
})
</script>
